import { useEffect, useRef, useState } from 'react';
import { useReactToPrint } from 'react-to-print';
import { Box, Paper, Button, Alert, Chip } from '@mui/material';
import DOMPurify from 'dompurify';
import { useStore } from 'src/stores/store';
import Iconify from 'src/components/Iconify';
import useLocales from 'src/hooks/useLocales';
import Loader from 'src/components/loader/Loader';
import { PATH_DASHBOARD } from 'src/routes/paths';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { DateConverter } from 'src/sections/common/DateConverter';
import { baseUrl } from 'src/api/baseUrl';

function PDFViewer() {
  const { ChoqorakCommonDropdown, ContractInfoStore } = useStore();
  const { loadTermsAndConditionDDL, TermsAndConditionOption } = ChoqorakCommonDropdown;
  const { selectedContractInfoDetail } = ContractInfoStore;
  const { translate } = useLocales();
  const [fontFamily, setFontFamily] = useState('Bahij-Zar-Regular');
  const [isLoad, setIsLoad] = useState(false);

  const reportExists = true;
  const contentToPrint = useRef(null);

  const handlePrint = useReactToPrint({
    pageStyle: `@page { size: A4; margin: 20mm; }`,
    content: () => contentToPrint.current,
  });

  useEffect(() => {
    setIsLoad(true);
    loadTermsAndConditionDDL(
      selectedContractInfoDetail!.contractStatusId === 11 ? 3 :
        selectedContractInfoDetail!.isTerminated
          ? 2
          : !selectedContractInfoDetail!.isExtendedContract && !selectedContractInfoDetail!.isContractExpired && selectedContractInfoDetail!.parentId! > 0
            ? 1

            : 0
    )
      .then(() => {
        setIsLoad(false);
      })
      .catch((error) => {
        console.error('Error loading terms and conditions:', error);
        setIsLoad(false);
      });
  }, [loadTermsAndConditionDDL]);

  const changeStartDateToDateFormat = new Date(selectedContractInfoDetail?.contractStartDate!);
  const changeEndDateToDateFormat = new Date(selectedContractInfoDetail?.contractEndDate!);
  const changeTerminationDateFormat = new Date(selectedContractInfoDetail?.terminationDate!);

  const changediscountStartDateToDateFormat = new Date(
    selectedContractInfoDetail?.discountStartDate!
  );
  const changediscountEndDateToDateFormat = new Date(selectedContractInfoDetail?.discountEndDate!);
  const toEnglishDigits = (str: string) =>
    str.replace(/[۰-۹]/g, (d) => '0123456789'['۰۱۲۳۴۵۶۷۸۹'.indexOf(d)]);

  const startDate = toEnglishDigits(
    new Intl.DateTimeFormat('fa-IR', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(
      changeStartDateToDateFormat!
    )
  );

  const endDate = toEnglishDigits(
    new Intl.DateTimeFormat('fa-IR', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(
      changeEndDateToDateFormat!
    )
  );


  const TerminateDate = selectedContractInfoDetail?.terminationDate ? toEnglishDigits(
    new Intl.DateTimeFormat('fa-IR', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(
      new Date(selectedContractInfoDetail?.terminationDate!)
    )
  ) : "";



  // const discountstartDate = toEnglishDigits(
  //   new Intl.DateTimeFormat('fa-IR', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(
  //     changediscountStartDateToDateFormat!
  //   )
  // );

  // const discountendDate = toEnglishDigits(
  //   new Intl.DateTimeFormat('fa-IR', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(
  //     changediscountEndDateToDateFormat!
  //   )
  // );

  const {
    contractId,
    contractNumber,
    customerId,
    contractTypeId,
    rentCarrencyId,
    contractStartDate,
    contractEndDate,
    needApproval,
    initialRentAmount,
    finalRentPerMonth,
    advancePayment,
    customerName,
    contractType,
    contractTypePashto,
    rentCarrency,
    rentCarrencyPashto,
    isContractExpired,
    isLocked,
    isApproved,
    totalContractDurationRent,
    totalContractDurationPaidRent,
    contractStatusId,
    contractStatus,
    isTerminated,
    isAdvanceRecieved,
    terminationDescription,
    terminationDate,
    settlmentDeductionAmount,
    deductedAmountFromAdvancePayment,
    manuallyPaidAmount,
    refundedAdvancePayment,
    remainAmount,
    deductionDescription,
    advanceRecievedByUserId,
    advanceRecievedByUserName,
    approvedBy,
    approvedByName,
    discountStartDate,
    discountEndDate,
    customerFatherName,
    customerGrandFatherName,
    customerPhone,
    customerTazkiraNo,
    customerMainProvence,
    customerMainProvencePashto,
    customerMainDistrict,
    customerMainDistrictPashto,
    customerMainAddress,
    customerCurrentProvence,
    customerCurrentProvencePashto,
    customerCurrentDistrict,
    customerCurrentDistrictPashto,
    customerCurrentAddress,
    customerPashtoName,
    contractDuration,
    customerTazkiraRegNo,
    customerTazkiraPageNo,
    customerTazkiraJoldNo,
    customerPhotoPath,
    shopId,
    shopCode,
    floorId,
    floorCode,

    shopTypePashto,
    blockId,
    blockName,
    contractCreatorPashtoName,
    contractCreatorFatherPashtoName,

    totalContractDurationRentWithoutDiscount,
    contractCreatorPashtoGrandFatherName,
  } = selectedContractInfoDetail ?? {};
  // .replace(/\d/g, (d) => '۰۱۲۳۴۵۶۷۸۹'[+d])
  const dynamicFields = {
    contractId: contractId?.toString() || '',
    contractNumber: contractNumber?.toString() || '',
    customerId: customerId?.toString() || '',
    contractTypeId: contractTypeId?.toString() || '',
    rentCarrencyId: rentCarrencyId?.toString() || '',
    contractStartDate: startDate?.toString() || '',
    contractEndDate: endDate?.toString() || '',
    terminationDate: TerminateDate?.toString() || '',
    needApproval: needApproval?.toString() || '',
    initialRentAmount: initialRentAmount?.toString() || '',
    finalRentPerMonth: finalRentPerMonth?.toString() || '',
    advancePayment: advancePayment?.toString() || '',
    customerName: customerName?.toString() || '',
    contractType: contractType?.toString() || '',
    contractTypePashto: contractTypePashto?.toString() || '',
    rentCarrency: rentCarrency?.toString() || '',
    rentCarrencyPashto: rentCarrencyPashto?.toString() || '',
    isContractExpired: isContractExpired?.toString() || '',
    isLocked: isLocked?.toString() || '',
    isApproved: isApproved?.toString() || '',
    totalContractDurationRent: totalContractDurationRent?.toString() || '',
    totalContractDurationPaidRent: totalContractDurationPaidRent?.toString() || '',
    contractStatusId: contractStatusId?.toString() || '',
    contractStatus: contractStatus?.toString() || '',
    isTerminated: isTerminated?.toString() || '',
    // contractDuration: contractDuration?.toString() || '',
    contractDuration: `\u200F${contractDuration?.toString()}` || '',
    isAdvanceRecieved: isAdvanceRecieved?.toString() || '',
    terminationDescription: terminationDescription?.toString() || '',
    settlmentDeductionAmount: settlmentDeductionAmount?.toString() || '',
    deductedAmountFromAdvancePayment: deductedAmountFromAdvancePayment?.toString() || '',
    manuallyPaidAmount: manuallyPaidAmount?.toString() || '',
    refundedAdvancePayment: refundedAdvancePayment?.toString() || '',
    remainAmount: remainAmount?.toString() || '',
    deductionDescription: deductionDescription?.toString() || '',
    advanceRecievedByUserId: advanceRecievedByUserId?.toString() || '',
    advanceRecievedByUserName: advanceRecievedByUserName?.toString() || '',
    approvedBy: approvedBy?.toString() || '',
    approvedByName: approvedByName?.toString() || '',
    // discountStartDate: discountstartDate?.toString() || '',
    // discountEndDate: discountendDate?.toString() || '',
    customerFatherName: customerFatherName?.toString() || '',
    customerGrandFatherName: customerGrandFatherName?.toString() || '',
    customerPhone: customerPhone?.toString() || '',
    customerTazkiraNo: customerTazkiraNo?.toString() || '',
    customerTazkiraJoldNo: customerTazkiraJoldNo?.toString() || '',
    customerTazkiraPageNo: customerTazkiraPageNo?.toString() || '',
    customerTazkiraRegNo: customerTazkiraRegNo?.toString() || '',
    customerMainProvence: customerMainProvence?.toString() || '',
    customerMainProvencePashto: customerMainProvencePashto?.toString() || '',
    customerMainDistrict: customerMainDistrict?.toString() || '',
    customerMainDistrictPashto: customerMainDistrictPashto?.toString() || '',
    customerMainAddress: customerMainAddress?.toString() || '',
    customerCurrentProvence: customerCurrentProvence?.toString() || '',
    customerCurrentProvencePashto: customerCurrentProvencePashto?.toString() || '',
    customerCurrentDistrict: customerCurrentDistrict?.toString() || '',
    customerCurrentDistrictPashto: customerCurrentDistrictPashto?.toString() || '',
    customerCurrentAddress: customerCurrentAddress?.toString() || '',
    customerPashtoName: customerPashtoName?.toString() || '',
    customerPhotoPath: customerPhotoPath?.toString() || '',
    shopId: shopId?.toString() || '',
    shopCode: shopCode?.toString() || '',
    floorId: floorId?.toString() || '',
    floorCode: floorCode?.toString() || '',
    shopTypePashto: shopTypePashto?.toString() || '',
    blockId: blockId?.toString() || '',
    blockName: blockName?.toString() || '',
    contractCreatorPashtoName: contractCreatorPashtoName?.toString() || '',
    contractCreatorFatherPashtoName: contractCreatorFatherPashtoName?.toString() || '',
    contractCreatorPashtoGrandFatherName: contractCreatorPashtoGrandFatherName?.toString() || '',
    totalContractDurationRentWithoutDiscount:
      totalContractDurationRentWithoutDiscount?.toString() || '',
  };

  // Function to replace dynamic placeholders with values from dynamicFields object
  // const replaceDynamicFields = (content: string) => {
  //   let updatedContent = content;
  //   Object.keys(dynamicFields).forEach((key) => {
  //     const regex = new RegExp(`{${key}}`, 'g'); // Find placeholder {key}
  //     updatedContent = updatedContent.replace(
  //       regex,
  //       dynamicFields[key as keyof typeof dynamicFields]
  //     );
  //   });
  //   return updatedContent;
  // };

  const replaceDynamicFields = (content: string) => {
    let updatedContent = content;

    Object.keys(dynamicFields).forEach((key) => {
      const regex = new RegExp(`\\{${key}\\}`, 'g'); // بهبود یافتن الگو برای پیدا کردن {key}
      const value = dynamicFields[key as keyof typeof dynamicFields];

      // بررسی مقدار null، undefined، و جایگزینی مقدار نامعتبر با ""
      updatedContent = updatedContent.replace(
        regex,
        value && value !== null && value !== undefined && value !== '' ? value : ''
      );
    });
    // {customerTazkiraRegNo} {customerTazkiraJoldNo} {customerTazkiraPageNo}

    return updatedContent;
  };

  // Sanitize and replace dynamic fields in content
  const decodedContent = TermsAndConditionOption?.[0]?.text?.replace(/\\\"/g, '"') || '';
  let sanitizedContent = DOMPurify.sanitize(decodedContent);

  // Replace placeholders with dynamic values
  sanitizedContent = replaceDynamicFields(sanitizedContent);

  //#region split content

  const [contentPages, setContentPages] = useState<string[]>([]); // State to store the split pages

  const handleSplitContent = (content: string) => {
    const pageHeight = 1200; // Height of one page in pixels (adjust as needed)
    const container = document.createElement('div');
    container.style.width = '800px'; // Set width similar to the page container
    container.style.position = 'absolute  ';
    container.style.visibility = 'hidden';
    container.innerHTML = content;

    document.body.appendChild(container);

    let currentPageContent = '';
    let pages: string[] = [];

    const children = Array.from(container.children);

    let currentHeight = 0;
    for (const child of children) {
      // Add content one by one and check for overflow
      container.innerHTML = currentPageContent + child.outerHTML;

      // Check if the content exceeds the page height
      if (container.offsetHeight > pageHeight) {
        pages.push(currentPageContent); // Push the current page's content
        currentPageContent = child.outerHTML; // Start a new page
      } else {
        currentPageContent += child.outerHTML; // Continue appending content
      }
    }

    // If any content remains after the loop, add it to the last page
    if (currentPageContent) {
      pages.push(currentPageContent);
    }

    document.body.removeChild(container); // Clean up

    return pages; // Return the content divided into pages
  };

  useEffect(() => {
    // Example content to split
    const content = sanitizedContent; // This can be any large content
    const splitContent = handleSplitContent(content);

    setContentPages(splitContent); // Store the result in state
  }, [sanitizedContent]); // Run only once when the component mounts

  //#endregion

  const tableCellStyle: React.CSSProperties = {
    border: '1px solid black',

    textAlign: 'center',
    fontSize: '14px',
  };

  const tableHeaderStyle: React.CSSProperties = {
    border: '1px solid black',

    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: '16px',
  };

  const signatureCellStyle: React.CSSProperties = {
    textAlign: 'center',
    fontSize: '14px',
  };

  let Url = baseUrl;

  return (
    <Box sx={{ p: 2 }} className="h-screen overflow-hidden overflow-y-auto">
      <Paper elevation={3} sx={{ p: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button
            variant="contained"
            color="error"
            startIcon={<Iconify icon="eva:arrow-ios-back-fill" />}
            component={RouterLink}
            to={PATH_DASHBOARD.ContractInfo.list}
          >
            {' '}
            {translate('CRUD.BackToList')}
          </Button>

          <Button
            variant="contained"
            color="success"
            startIcon={<Iconify icon="eva:printer-outline" />}
            onClick={handlePrint}
          >
            {translate('Income.Print')}
          </Button>
        </Box>
      </Paper>

      {isLoad ? (
        <Loader />
      ) : reportExists ? (
        <div ref={contentToPrint}>
          {contentPages.map((page, index) => (
            <Box sx={{  }} key={index}>
              <div>
                <Box
                  sx={{
                    width: '210mm',
                    height: '297mm',
                    margin: '0 auto',
                    backgroundColor: 'white',
                    color: 'black',
                    position: 'relative',
                    fontFamily,
                    padding: '5mm',
                    // boxSizing: 'border-box'
                  }}
                >
                  {index === 0 && (
                    <>
                      <img
                        // src="/Images/Choqorak Brand logo-03.png"
                        src={
                          selectedContractInfoDetail?.customerPhotoPath
                            ? `${Url + selectedContractInfoDetail?.customerPhotoPath}`
                            : '/Images/avatar.jpg'
                        }
                        alt="CustomerPhoto"
                        style={{
                          width: '130px',
                          height: '140px',
                          float: 'left',
                          position: 'absolute',
                          top: '20px',
                          border: '1px solid lightgray',
                        }}
                      />

                      <img
                        src="/Images/Choqorak Brand logo-03.png"
                        alt="Footer"
                        style={{
                          width: '120px',
                          height: '120px',
                          float: 'right',
                          position: 'absolute',
                          top: '0',
                          right: '20px',
                        }}
                      />
                    </>
                  )}
                  {/* <img
                    src="/Images/choqorak name with old logo-01-01.png"
                    alt="Footer"
                    style={{ width: '300px', height: '50px', float: 'right' }}
                  /> */}
                  {/* Content */}
                  <Box
                    sx={{
                      textAlign: 'center',
                      position: 'relative',
                      marginTop: index === 0 ? '0mm' : '7mm',
                      width: '100%',
                      top: index === 0 ? '0px' : '-20px',
                      direction: 'rtl',
                    }}
                  >
                    <div
                      className="content"
                      style={{ width: '100%', direction: 'rtl' }}
                      dangerouslySetInnerHTML={{ __html: page }}
                    />
                  </Box>

                  {index === contentPages.length - 1 ? (
                    <Box
                      sx={{
                        textAlign: 'center',
                        width: '100%',
                        position: 'absolute',

                        left: '50%',
                        transform: 'translateX(-45%)',
                      }}
                    >
                      <img
                        src="/Images/footer QGC_Dari-01.png"
                        alt="Footer"
                        style={{ width: '700px', height: '120px' }}
                      />
                    </Box>
                  ) : null}
                </Box>
              </div>
            </Box>
          ))}

          {selectedContractInfoDetail!.isTerminated ||
            selectedContractInfoDetail!.isExtendedContract || selectedContractInfoDetail!.contractStatusId === 11 || selectedContractInfoDetail!.parentId! > 0 ? (
            ''
          ) : (
            <Box sx={{ mt: 2 }}>
              <div>
                <Box
                  sx={{
                    width: '210mm',
                    height: '297mm',
                    margin: '0 auto',
                    backgroundColor: 'white',
                    position: 'relative',
                    fontFamily,
                    padding: '5mm',
                    color: 'black',
                    direction: 'rtl',
                  }}
                >
                  {/* Header Logos */}

                  <img
                    src="/Images/Choqorak Brand logo-03.png"
                    alt="Header Logo"
                    style={{
                      width: '100px',
                      height: '100px',
                      float: 'left',
                      position: 'absolute',
                      top: '0',
                    }}
                  />

                  {/* Tenant and Shop Information Tables */}
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3, mt: 10 }}>
                    {/* Tenant Information Table */}

                    {/* Shop Information Table */}
                    <table
                      style={{
                        width: '45%',
                        borderCollapse: 'collapse',
                        border: '1px solid black',
                      }}
                    >
                      <thead>
                        <tr style={{ backgroundColor: '#f0f0f0', textAlign: 'center' }}>
                          <th colSpan={2} style={tableHeaderStyle}>
                            مشخصات دکان / دفتر
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td style={tableCellStyle}>دکان / دفتر</td>
                          <td style={tableCellStyle}>
                            {selectedContractInfoDetail?.shopTypePashto}
                          </td>
                        </tr>
                        <tr>
                          <td style={tableCellStyle}>موقعیت بلاک</td>
                          <td style={tableCellStyle}>{selectedContractInfoDetail?.blockName}</td>
                        </tr>
                        <tr>
                          <td style={tableCellStyle}>طبقه</td>
                          <td style={tableCellStyle}>{selectedContractInfoDetail?.floorCode}</td>
                        </tr>
                        <tr>
                          <td style={tableCellStyle}>نمبر دکان / دفتر</td>
                          <td style={tableCellStyle}>{selectedContractInfoDetail?.shopCode}</td>
                        </tr>
                      </tbody>
                    </table>

                    <table
                      style={{
                        width: '45%',
                        borderCollapse: 'collapse',
                        border: '1px solid black',
                      }}
                    >
                      <thead>
                        <tr style={{ backgroundColor: '#f0f0f0', textAlign: 'center' }}>
                          <th colSpan={2} style={tableHeaderStyle}>
                            مشخصات مستأجر
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td style={tableCellStyle}>اسم و تخلص</td>
                          <td style={tableCellStyle}>
                            {selectedContractInfoDetail?.customerPashtoName}
                          </td>
                        </tr>
                        <tr>
                          <td style={tableCellStyle}>ولد</td>
                          <td style={tableCellStyle}>
                            {selectedContractInfoDetail?.customerFatherName}
                          </td>
                        </tr>
                        <tr>
                          <td style={tableCellStyle}>پیش پرداخت دکان</td>
                          <td style={tableCellStyle}>
                            {selectedContractInfoDetail?.advancePayment}
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={2} style={{ ...tableCellStyle, textAlign: 'center' }}>
                            امضاء: ........................
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </Box>

                  {/* Document Title */}
                  <Box sx={{ textAlign: 'right', mt: 5, mb: 1 }}>
                    <h6 style={{ fontWeight: 'bold' }}>چک لیست دکاکین و دفاتر سرای چُقرک</h6>
                  </Box>

                  {/* Tenant Information Table */}

                  {/* Checklist Table */}
                  <Box sx={{ mb: 3 }}>
                    <table
                      style={{
                        width: '100%',
                        borderCollapse: 'collapse',
                        border: '1px solid black',
                      }}
                    >
                      <thead>
                        <tr style={{ backgroundColor: '#f0f0f0', textAlign: 'center' }}>
                          <th style={tableHeaderStyle}>شماره</th>
                          <th style={tableHeaderStyle}>وسایل</th>
                          <th style={tableHeaderStyle}>تسلیم دهی</th>
                          <th style={tableHeaderStyle}>تسلیم گیری</th>
                          <th style={tableHeaderStyle}>توضیحات</th>
                        </tr>
                      </thead>
                      <tbody>
                        {[
                          'غرفه داخل دکان',
                          'وسایل آشپزخانه (سینک ظرفشوی، اجاق برقی و الماری مجهز)',
                          'تشناب (تب دستشوی، آینه و کمود)',
                          'مسطح',
                          'ساکت و گروپ برق',
                          'فیوز باکس',
                          'دروازه و چوکات PVC همرای شیشه',
                          'دروازه کرکره ای',
                          'UPS و کلید ریموت',
                          'میتر برق',
                        ].map((item, index) => (
                          <tr key={index}>
                            <td style={tableCellStyle}>{index + 1}</td>
                            <td style={tableCellStyle}>{item}</td>
                            <td style={tableCellStyle}></td>
                            <td style={tableCellStyle}></td>
                            {index === 0 ? (
                              <td rowSpan={item.length} style={tableCellStyle}></td>
                            ) : null}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </Box>

                  {/* Signature Section */}
                  <Box sx={{ mt: 5 }}>
                    <h3 style={{ fontWeight: 'bold' }}>مسؤلین نظارت در تسلیم دهی</h3>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                      <tbody>
                        <tr>
                          <td style={signatureCellStyle}>حسن صفریان (انجنیرناظر)</td>
                          <td style={signatureCellStyle}>همایون صبور (مسؤل مارکیت)</td>
                          <td style={signatureCellStyle}>محمد محمدی (میخانیک برق)</td>
                          <td style={signatureCellStyle}>محمد ابراهیمی (مسئول چوکیداران)</td>
                        </tr>
                        <tr>
                          <td style={signatureCellStyle}>..................</td>
                          <td style={signatureCellStyle}>..................</td>
                          <td style={signatureCellStyle}>..................</td>
                          <td style={signatureCellStyle}>..................</td>
                        </tr>
                      </tbody>
                    </table>
                    <h3>
                      <strong>تاریخ تسلیم دهی</strong> &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; /
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;/
                    </h3>
                    <h3>
                      <strong>یاداشت</strong>{' '}
                      .........................................................................................................................................
                    </h3>

                    <h3>
                      <strong>نوت</strong>:وسایل مورد نیاز طبق چک لیست فوق درشروع قرارداد به
                      مستاجرتسلیم داده شده و در زمان فسخ قرارداد طبق جدول تسلیم دهی بصورت کامل وسالم
                      تسلیم گرفته میشود در صورت شکستن یا خراب نمودن هر یک از وسایل، مستاجر مکلف است
                      که قیمت آن را به دفتر مارکیت پرداخت نماید.
                    </h3>
                  </Box>

                  <Box sx={{ mt: 5 }}>
                    <h3 style={{ fontWeight: 'bold' }}>مسؤلین نظارت در تسلیم گیری</h3>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                      <tbody>
                        <tr>
                          <td style={signatureCellStyle}>حسن صفریان (انجنیرناظر)</td>
                          <td style={signatureCellStyle}>همایون صبور (مسؤل مارکیت)</td>
                          <td style={signatureCellStyle}>محمد محمدی (میخانیک برق)</td>
                          <td style={signatureCellStyle}>محمد ابراهیمی (مسئول چوکیداران)</td>
                        </tr>
                        <tr>
                          <td style={signatureCellStyle}>..................</td>
                          <td style={signatureCellStyle}>..................</td>
                          <td style={signatureCellStyle}>..................</td>
                          <td style={signatureCellStyle}>..................</td>
                        </tr>
                      </tbody>
                    </table>
                    <h3>
                      <strong>تاریخ تسلیم گیری</strong> &nbsp;&nbsp;&nbsp; &nbsp;&nbsp;&nbsp; /
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;/
                    </h3>
                    <h3>
                      <strong>یاداشت</strong>{' '}
                      .........................................................................................................................................
                    </h3>
                  </Box>

                  {/* Footer */}
                  <Box
                    sx={{
                      textAlign: 'center',
                      width: '100%',
                      position: 'absolute',
                      bottom: '0.1mm',
                      left: '50%',
                      transform: 'translateX(-57%)',
                    }}
                  >
                    <img
                      src="/Images/footer QGC_Dari-01.png"
                      alt="Footer"
                      style={{ width: '700px', height: '120px' }}
                    />
                  </Box>
                </Box>
              </div>
            </Box>
          )}
        </div>
      ) : (
        <Alert severity="error">
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <span>There is no document selected. Please go back.</span>
            <Chip
              sx={{ mt: -1, ml: 1 }}
              color="secondary"
              label={translate('CRUD.BackToList')}
              onClick={() => console.log('Clear selection and navigate back')}
            />
          </Box>
        </Alert>
      )}
    </Box>
  );
}

export default PDFViewer;
